/* Ken Burns pan/zoom — UrbanOudAirNYC hero banner.
   Finds the hero(es) using the NYC skyline artwork and adds a class that
   drives a slow CSS scale+drift (see hero-kenburns.css). Replaces the
   previous twinkle-canvas effect. */
(function () {
  'use strict';

  var TARGET_IMAGE_FRAGMENT = '0206998c-8134-48a4-968d-1ac8ba6b674b';

  function init() {
    var heroes = document.querySelectorAll('.hero');
    heroes.forEach(function (heroEl) {
      var imgs = heroEl.querySelectorAll('img[src*="' + TARGET_IMAGE_FRAGMENT + '"]');
      imgs.forEach(function (img) {
        img.classList.add('hero-kenburns');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
